export const viewTitle = "Журнал обновления справочников в ОИК";
export const viewUniqKey = "syncLogOik";
